import {useLang} from '../../../../_metronic/i18n/Metronici18n'
import {useAuth} from './Auth'
import {AuthModel} from './_models'
import {listUserClaim} from './_requests'

const AUTH_LOCAL_STORAGE_KEY = 'kt-auth-react-v'
const getAuth = (): AuthModel | undefined => {
  if (!localStorage) {
    return
  }

  const lsValue: string | null = localStorage.getItem(AUTH_LOCAL_STORAGE_KEY)
  if (!lsValue) {
    return
  }

  try {
    const auth: AuthModel = JSON.parse(lsValue) as AuthModel
    if (auth) {
      // You can easily check auth_token expiration also
      return auth
    }
  } catch (error) {
    console.error('AUTH LOCAL STORAGE PARSE ERROR', error)
  }
}

const setAuth = (auth: AuthModel) => {
  if (!localStorage) {
    return
  }

  try {
    const lsValue = JSON.stringify(auth)
    localStorage.setItem(AUTH_LOCAL_STORAGE_KEY, lsValue)
  } catch (error) {
    console.error('AUTH LOCAL STORAGE SAVE ERROR', error)
  }
}

const removeAuth = () => {
  if (!localStorage) {
    return
  }

  try {
    localStorage.removeItem(AUTH_LOCAL_STORAGE_KEY)
  } catch (error) {
    console.error('AUTH LOCAL STORAGE REMOVE ERROR', error)
  }
}

export function setupAxios(axios: any) {
  axios.defaults.headers.Accept = 'application/json'
  axios.interceptors.request.use(
    (config: {headers: {Authorization: string}}) => {
      const auth = getAuth()
      if (auth && auth.api_token) {
        config.headers.Authorization = `Bearer ${auth.api_token}`
      }

      return config
    },
    (err: any) => Promise.reject(err)
  )

  ///
  axios.interceptors.response.use(
    (response: any) => {
      if (response.headers['new-token']) {
        const {saveAuth} = useAuth()
        const newToken = response.headers['new-token']
        // newToken değerini kullan veya işle
        const auth = {
          api_token: String(newToken),
          refreshToken: String(newToken),
        }
        saveAuth(auth)
        // Axios istek yapılandırmasını güncelle
        axios.defaults.headers.common['Authorization'] = `Bearer ${newToken}`
        axios.defaults.headers.common['Accept-Language'] = useLang()
      }
      return response
    },
    (error: any) => {
      if (error.response && error.response.status === 401) {
        // API token geçersiz veya süresi dolmuş durumda
        removeAuth()
        document.location.replace('/auth/login')
      }
      /*  if (error.message === 'Network Error') {
        removeAuth()
        document.location.replace('/auth/login')
      }*/
      return Promise.reject(error)
    }
  )
}

async function getClaim(currentUser: any) {
  try {
    const {data} = await listUserClaim(Number(currentUser?.id))
    return data[0].name
  } catch (error) {
    return error
  }
}

export {getAuth, setAuth, removeAuth, AUTH_LOCAL_STORAGE_KEY, getClaim}
